import { Component, inject, isDevMode, ViewChild } from '@angular/core';
import { Performance } from '@angular/fire/performance';
import { Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, ofType } from '@ngrx/effects';
import { enumEquals, UserRole, UserRoleSchema } from '@vmspdb/definitions';
import { CommonAppComponent } from '@vmspdb/ui/common';
import { selectAuthUserRole, setAuthProjectID } from '@vmspdb/ui/store';
import { NgProgressbar } from 'ngx-progressbar';
import { filter, switchMap, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { InitializerService } from './services/initializer.service';
import { UtilitiesActions } from './store/utilities/utilities.actions';

@UntilDestroy()
@Component({
  selector: 'vmspdb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends CommonAppComponent {
  private nbAuth = inject(NbAuthService);
  private router = inject(Router);

  private actions$ = inject(Actions);
  @ViewChild(NgProgressbar) progressBar!: NgProgressbar;
  // performance = inject(Performance);

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  override ngOnInit() {
    this.store.dispatch(
      setAuthProjectID({
        projectID:
          environment.firebase.projectId ||
          InitializerService.environment().firebase.projectId,
      }),
    );

    if (!isDevMode()) {
      this.injector.get(Performance);
    }

    super.ngOnInit();

    this.store
      .select(selectAuthUserRole)
      .pipe(
        untilDestroyed(this),
        filter((role) => enumEquals(UserRoleSchema, role, UserRole.CLIENT)),
        switchMap(() => this.nbAuth.getToken()),
        switchMap((token) => this.nbAuth.logout(token.getOwnerStrategyName())),
        switchMap(() => this.router.navigateByUrl('/auth/login')),
      )
      .subscribe();

    this.actions$
      .pipe(
        untilDestroyed(this),
        ofType(UtilitiesActions.progress, UtilitiesActions.complete),
        tap(() => this.progressBar.start()),
      )
      .subscribe();

    this.actions$
      .pipe(
        untilDestroyed(this),
        ofType(UtilitiesActions.complete),
        tap(() => this.progressBar.complete()),
      )
      .subscribe();
  }
}
